import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {atom, useAtomValue, useSetAtom} from 'jotai';

const legendEnabledAtom = atom(false);
const legendOpenAtom = atom(false);

// "Atom-with-Effects" ref: https://github.com/pmndrs/jotai/issues/211#issuecomment-735008721
const toggleLegendWithAnalyticsAtom = atom(null, (get, set) => {
    const isLegendOpen = get(legendOpenAtom);

    set(legendOpenAtom, !isLegendOpen);

    // if open -> closed, send close event, & v.v.
    if (isLegendOpen) ampli.closeMapLegend();
    else ampli.openMapLegend();
});

const closeLegendAtom = atom(null, (_get, set) => set(legendOpenAtom, false));

export function useIsLegendEnabled() {
    return useAtomValue(legendEnabledAtom);
}

export function useSetIsLegendEnabled() {
    return useSetAtom(legendEnabledAtom);
}

export function useIsLegendOpen() {
    return useAtomValue(legendOpenAtom);
}

export function useToggleLegendWithAnalytics() {
    return useSetAtom(toggleLegendWithAnalyticsAtom);
}

export function useCloseLegend() {
    return useSetAtom(closeLegendAtom);
}
